import { lazyPage } from "@/router/lazyPage";

export const AccountShell = lazyPage(() => import("@/pages/Account/AccountShell"), "AccountShell");
export const FormFieldGallery = lazyPage(
  () => import("@/pages/Dev/FormFieldGallery"),
  "FormFieldGallery",
);
export const Home = lazyPage(() => import("@/pages/Home"), "Home");
export const CompanyTracking = lazyPage(
  () => import("@/pages/CompanyTracking/CompanyTracking"),
  "CompanyTracking",
);
export const SettingsProfile = lazyPage(
  () => import("@/pages/Settings/SettingsProfile"),
  "SettingsProfile",
);
export const ClientBudgets = lazyPage(
  () => import("@/pages/ClientBudgets/ClientBudgets"),
  "ClientBudgets",
);
